export const natureAnimalsQuestions = [
  {
    id: 'nature-001',
    category: 'Nature & Animals',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'Which animal is known as the fastest land animal?',
    options: ['Cheetah', 'Horse', 'Leopard', 'Gazelle'],
    answer: 'Cheetah',
    insight: 'Cheetahs can sprint at very high speeds in short bursts.',
    tags: ['animals', 'speed', 'cheetah'],
    points: 10,
  },
  {
    id: 'nature-002',
    category: 'Nature & Animals',
    difficulty: 'Easy',
    type: 'multiple',
    question: 'What is the largest mammal in the world?',
    options: ['Blue Whale', 'African Elephant', 'Giraffe', 'Hippopotamus'],
    answer: 'Blue Whale',
    insight: 'Blue whales are the largest animals known to have lived.',
    tags: ['animals', 'mammals', 'whales'],
    points: 10,
  },
  {
    id: 'nature-003',
    category: 'Nature & Animals',
    difficulty: 'Easy',
    type: 'true/false',
    question: 'Penguins are flightless birds.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Penguins are adapted for swimming rather than flying.',
    tags: ['birds', 'penguins', 'true false'],
    points: 10,
  },
  {
    id: 'nature-004',
    category: 'Nature & Animals',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which animal has three hearts?',
    options: ['Octopus', 'Dolphin', 'Turtle', 'Frog'],
    answer: 'Octopus',
    insight: 'Octopuses have two hearts for gills and one for the body.',
    tags: ['animals', 'octopus', 'biology'],
    points: 20,
  },
  {
    id: 'nature-005',
    category: 'Nature & Animals',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which plant part usually absorbs water from soil?',
    options: ['Roots', 'Flowers', 'Leaves', 'Seeds'],
    answer: 'Roots',
    insight: 'Roots absorb water and minerals for the plant.',
    tags: ['plants', 'roots', 'botany'],
    points: 20,
  },
  {
    id: 'nature-006',
    category: 'Nature & Animals',
    difficulty: 'Medium',
    type: 'true/false',
    question: 'Sharks are mammals.',
    options: ['True', 'False'],
    answer: 'False',
    insight: 'Sharks are fish with cartilage instead of bones.',
    tags: ['sharks', 'fish', 'animals'],
    points: 20,
  },
  {
    id: 'nature-007',
    category: 'Nature & Animals',
    difficulty: 'Medium',
    type: 'multiple',
    question: 'Which country is home to the kangaroo?',
    options: ['Australia', 'India', 'Brazil', 'South Africa'],
    answer: 'Australia',
    insight: 'Kangaroos are native to Australia.',
    tags: ['kangaroo', 'australia', 'animals'],
    points: 20,
  },
  {
    id: 'nature-008',
    category: 'Nature & Animals',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'What process do plants use to make food from sunlight?',
    options: ['Photosynthesis', 'Fermentation', 'Respiration', 'Germination'],
    answer: 'Photosynthesis',
    insight: 'Photosynthesis converts sunlight into chemical energy.',
    tags: ['plants', 'photosynthesis', 'energy'],
    points: 30,
  },
  {
    id: 'nature-009',
    category: 'Nature & Animals',
    difficulty: 'Hard',
    type: 'multiple',
    question: 'Which bird is known for its ability to mimic human speech?',
    options: ['Parrot', 'Ostrich', 'Penguin', 'Swan'],
    answer: 'Parrot',
    insight: 'Many parrots can mimic sounds, including speech.',
    tags: ['birds', 'parrots', 'mimicry'],
    points: 30,
  },
  {
    id: 'nature-010',
    category: 'Nature & Animals',
    difficulty: 'Hard',
    type: 'true/false',
    question: 'Banana plants are technically herbs.',
    options: ['True', 'False'],
    answer: 'True',
    insight: 'Banana plants have herbaceous stems rather than woody trunks.',
    tags: ['plants', 'bananas', 'botany'],
    points: 30,
  },
];
